import { gql } from '@apollo/client';

export const getBlogDetails = gql`
query getBlogDetails($currentPage: Int, $searchList: String) {
  getBlogDetails(currentPage: $currentPage, searchList: $searchList) {
    count
    results {
      id
      metaTitle
      metaDescription
      pageUrl
      pageTitle
      content
      footerCategory
      isEnable
      createdAt
    }
  }
}

    `;

export const deleteBlogDetailsMutation = gql`
    mutation deleteBlogDetails ($id: Int!) {
        deleteBlogDetails (id: $id) {
            status
        }
        }
    `;

export const updateBlogStatusMutation = gql`
    mutation updateBlogStatus ($id: Int, $isEnable: Boolean){
      updateBlogStatus(id: $id, isEnable: $isEnable){
            status
        }
    }
    `;